import { render } from "./dashboard.vue?vue&type=template&id=1b97d390&scoped=true&class=bg-gray-bgcolor"
import script from "./dashboard.vue?vue&type=script&lang=js"
export * from "./dashboard.vue?vue&type=script&lang=js"

import "./dashboard.vue?vue&type=style&index=0&id=1b97d390&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1b97d390"

export default script